import { render, staticRenderFns } from "./Infobox.vue?vue&type=template&id=501f28f4&scoped=true&"
import script from "./Infobox.vue?vue&type=script&lang=ts&"
export * from "./Infobox.vue?vue&type=script&lang=ts&"
import style0 from "./Infobox.vue?vue&type=style&index=0&id=501f28f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f28f4",
  null
  
)

export default component.exports